import React from "react";

export default function Arrow({ width = "24px", height = "24px" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill="#000"
    >
      <path d="m330-444 201 201-51 51-288-288 288-288 51 51-201 201h438v72H330Z" />
    </svg>
  );
}
